import Vue from 'vue'
import Vuex from 'vuex'
import countries from './countries'
import XMPhtml from './XMPhtml'
import DynamicBannerHtmlExample from './DynamicBannerHtmlExample'
import apiKey from './apiKey'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    countries: countries,
    XMPhtml: XMPhtml,
    DynamicBannerHtmlExample: DynamicBannerHtmlExample,
    apiKey: apiKey,
    permission: localStorage.getItem('permission') || 0
  },
  mutations: {
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, token, user) {
      state.status = 'success'
      state.token = token
      state.user = user
    },
    set_permission (state, payload) {
      state.permission = payload
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
    }
  },
  actions: {
    login ({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios.post(`${this._vm.$api_url}/auth/login`, user)
          .then(resp => {
            const token = resp.data.access_token.token
            const user = resp.data.user
            localStorage.setItem('token', token)
            localStorage.setItem('permission', resp.data.user.permission || 0)
            commit('set_permission', resp.data.user.permission || 0)
            axios.defaults.headers.common.Authorization = `Bearer ${token}`
            commit('auth_success', token, user)
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('permission')
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('permission')
        delete axios.defaults.headers.common.Authorization
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    countries: state => state.countries,
    XMPhtml: state => state.XMPhtml,
    DynamicBannerHtmlExample: state => state.DynamicBannerHtmlExample,
    apiKey: state => state.apiKey,
    permission: state => state.permission,
    user: state => state.user
  },
  modules: {
  }
})
